<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_015.vue?68a1152c